import { getI18nFromGeneral } from '@/src/tools/tools';
import { modal } from '@/src/utils/Modal';
import React from 'react';
import Webcam from 'react-webcam';

const Camera = (props) => {
  const {
    videoConstraints,
    width,
    height,
    onUserMediaError,
    onError,
    cameraRef,
    ...rest
  } = props;
  return (
    <Webcam
      videoConstraints={videoConstraints}
      width={width}
      screenshotFormat='image/jpeg'
      height={height}
      ref={cameraRef}
      screenshotQuality={1}
      onUserMediaError={(e) => {
        if (onUserMediaError) {
          onUserMediaError(e);
          return;
        }
        modal.error({
          title: getI18nFromGeneral('general.webcam.camera_error'),
          content: e.toString() || getI18nFromGeneral('general.webcam.contact'),
          onOkText: getI18nFromGeneral('general.antd.Uploader.ok'),
          onOk: () => {
            // console.log(onCancel);
            if (onError) {
              onError();
            }
          },
        });
      }}
      {...rest}
    />
  );
};
export default Camera;
